





















































































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

import AbstractAddItem_Step2 from '../AbstractAddItem-Step2.vue';
import { PlaceItem } from '@/models/items/place-item-model';
import ErrorWrappedTextInput from '@/components/form-elements/ErrorWrappedTextInput.vue';

import { gmapApi } from 'vue2-google-maps';
import axios from 'axios';

@Component({ components: { ErrorWrappedTextInput } })
export default class AddPlaceItem_Step2 extends AbstractAddItem_Step2 {
  @Prop(PlaceItem) item: PlaceItem;
  manuallyUpdatedMarker: boolean = false;
  lastGeocodeQuery: string = '';
  addedMarker: boolean = false;

  get latitude() {
    return this.item.latitude || 40.74;
  }
  get longitude() {
    return this.item.longitude || -74;
  }

  get addressLine() {
    return `${this.item.addressLine1 || ''} ${this.item.city || ''} ${this.item
      .state || ''} ${this.item.zip || ''}  ${this.item.country || ''}`;
  }

  public renderEsriResponse(results: any) {
    
    if (
      !results.data.candidates ||
      results.data.candidates.length == 0 ||
      results.data.candidates[0].score < 99
    ) {
      console;
      return;
    }

    this.item.latitude = results.data.candidates[0].location.y;
    this.item.longitude = results.data.candidates[0].location.x;
    this.maybeAddMarker();
  }

  maybeGeocodeAddress() {
    if (this.manuallyUpdatedMarker) {
      return;
    }

    if (!this.item.city || !this.item.addressLine1) {
      return;
    }

    if (this.lastGeocodeQuery == this.addressLine) {
      return;
    }

    this.lastGeocodeQuery = this.addressLine;

    const searchUrl =
      'https://geocode.arcgis.com/arcgis/rest/services/World/GeocodeServer/findAddressCandidates';
    const searchParams = {
      category: 'Address',
      outFields:
        'PlaceName,Type,Place_Addr,City,Region,Phone,Neighborhood,URL,Type,StAddr,SubAddr,Country,Postal',
      maxLocations: 20,
      // TODO: flip to true + add api key
      forStorage: 'false',
      f: 'pjson'
    };

    const query = this.addressLine;
    const self = this;
    axios({
      url: searchUrl,
      params: {
        ...searchParams,
        singleLine: query
      }
    })
      .then(this.renderEsriResponse)
      .catch(function(error) {
        // handle error
        
      });
  }

  isFormValid(): boolean {
    if (!this.item.latitude) {
      
      return false;
    }

    return true;
  }

  mounted() {
    if (this.item.latitude) {
      this.maybeAddMarker();
    }
  }

  maybeAddMarker() {
    if (this.addedMarker) {
      return;
    }

    this.addedMarker = true;
    // @ts-ignore
    this.$refs.mapRef.$mapPromise.then(map => {
      
      // @ts-ignore
      const marker = new window.google.maps.Marker({
        position: { lat: this.item.latitude, lng: this.item.longitude },
        map: map,
        draggable: true
      });

      marker.addListener('dragend', this.onMarkerDrag);
    });
  }

  onMarkerDrag(dragEvent: any) {
    this.item.latitude = dragEvent.latLng.lat();
    this.item.longitude = dragEvent.latLng.lng();
    this.manuallyUpdatedMarker = true;
  }

  onMapClick(clickEvent: any) {
    if (!this.item.latitude) {
      this.item.latitude = clickEvent.latLng.lat();
      this.item.longitude = clickEvent.latLng.lng();

      this.maybeAddMarker();
    }
  }
}
